import { render, staticRenderFns } from "./before-out-import.vue?vue&type=template&id=2d06bbbe&scoped=true"
import script from "./before-out-import.vue?vue&type=script&lang=ts"
export * from "./before-out-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06bbbe",
  null
  
)

export default component.exports